import { render } from "./Supports.vue?vue&type=template&id=6e58c816&scoped=true"
import script from "./Supports.vue?vue&type=script&lang=js"
export * from "./Supports.vue?vue&type=script&lang=js"

import "./Supports.vue?vue&type=style&index=0&id=6e58c816&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e58c816"]])

export default __exports__